import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modern-utility',
  templateUrl: './modern-utility.component.html',
  styleUrls: ['./modern-utility.component.sass']
})
export class ModernUtilityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
